export default "<app-back-button></app-back-button>\n<router-outlet></router-outlet>\n";